export const SansFontBold = {
    glyphs: {
        '0': {
            xMin: 86,
            xMax: 1038,
            yMin: -25,
            yMax: 1472,
            ha: 1497,
            leftSideBearing: 86,
            advanceWidth: 1139,
        },
        '1': {
            xMin: 162,
            xMax: 806,
            yMin: 0,
            yMax: 1472,
            ha: 1472,
            leftSideBearing: 162,
            advanceWidth: 1139,
        },
        '2': {
            xMin: 51,
            xMax: 1036,
            yMin: 0,
            yMax: 1472,
            ha: 1472,
            leftSideBearing: 51,
            advanceWidth: 1139,
        },
        '3': {
            xMin: 77,
            xMax: 1051,
            yMin: -25,
            yMax: 1472,
            ha: 1497,
            leftSideBearing: 77,
            advanceWidth: 1139,
        },
        '4': {
            xMin: 38,
            xMax: 1092,
            yMin: 0,
            yMax: 1472,
            ha: 1472,
            leftSideBearing: 38,
            advanceWidth: 1139,
        },
        '5': {
            xMin: 91,
            xMax: 1077,
            yMin: -25,
            yMax: 1446,
            ha: 1471,
            leftSideBearing: 91,
            advanceWidth: 1139,
        },
        '6': {
            xMin: 87,
            xMax: 1066,
            yMin: -25,
            yMax: 1472,
            ha: 1497,
            leftSideBearing: 87,
            advanceWidth: 1139,
        },
        '7': {
            xMin: 87,
            xMax: 1048,
            yMin: 0,
            yMax: 1446,
            ha: 1446,
            leftSideBearing: 87,
            advanceWidth: 1139,
        },
        '8': {
            xMin: 83,
            xMax: 1047,
            yMin: -26,
            yMax: 1472,
            ha: 1498,
            leftSideBearing: 83,
            advanceWidth: 1139,
        },
        '9': {
            xMin: 65,
            xMax: 1044,
            yMin: -26,
            yMax: 1472,
            ha: 1498,
            leftSideBearing: 65,
            advanceWidth: 1139,
        },
        ' ': {
            xMin: 0,
            xMax: 0,
            yMin: 0,
            yMax: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 569,
        },
        '!': {
            xMin: 184,
            xMax: 488,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 184,
            advanceWidth: 682,
        },
        '"': {
            xMin: 112,
            xMax: 869,
            yMin: 945,
            yMax: 1466,
            ha: 521,
            leftSideBearing: 112,
            advanceWidth: 971,
        },
        '#': {
            xMin: 18,
            xMax: 1115,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 18,
            advanceWidth: 1139,
        },
        $: {
            xMin: 70,
            xMax: 1048,
            yMin: -205,
            yMax: 1584,
            ha: 1789,
            leftSideBearing: 70,
            advanceWidth: 1139,
        },
        '%': {
            xMin: 89,
            xMax: 1725,
            yMin: -59,
            yMax: 1491,
            ha: 1550,
            leftSideBearing: 89,
            advanceWidth: 1821,
        },
        '&': {
            xMin: 90,
            xMax: 1446,
            yMin: -38,
            yMax: 1491,
            ha: 1529,
            leftSideBearing: 90,
            advanceWidth: 1479,
        },
        "'": {
            xMin: 92,
            xMax: 398,
            yMin: 945,
            yMax: 1466,
            ha: 521,
            leftSideBearing: 92,
            advanceWidth: 487,
        },
        '(': {
            xMin: 107,
            xMax: 616,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 107,
            advanceWidth: 682,
        },
        ')': {
            xMin: 67,
            xMax: 576,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 67,
            advanceWidth: 682,
        },
        '*': {
            xMin: 28,
            xMax: 753,
            yMin: 792,
            yMax: 1491,
            ha: 699,
            leftSideBearing: 28,
            advanceWidth: 797,
        },
        '+': {
            xMin: 85,
            xMax: 1110,
            yMin: 211,
            yMax: 1236,
            ha: 1025,
            leftSideBearing: 85,
            advanceWidth: 1196,
        },
        ',': {
            xMin: 117,
            xMax: 421,
            yMin: -327,
            yMax: 281,
            ha: 608,
            leftSideBearing: 117,
            advanceWidth: 569,
        },
        '-': {
            xMin: 115,
            xMax: 667,
            yMin: 391,
            yMax: 672,
            ha: 281,
            leftSideBearing: 115,
            advanceWidth: 682,
        },
        '.': {
            xMin: 147,
            xMax: 428,
            yMin: 0,
            yMax: 281,
            ha: 281,
            leftSideBearing: 147,
            advanceWidth: 569,
        },
        '/': {
            xMin: -3,
            xMax: 571,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: -3,
            advanceWidth: 569,
        },
        ':': {
            xMin: 201,
            xMax: 482,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 201,
            advanceWidth: 682,
        },
        ';': {
            xMin: 170,
            xMax: 474,
            yMin: -327,
            yMax: 1062,
            ha: 1389,
            leftSideBearing: 170,
            advanceWidth: 682,
        },
        '<': {
            xMin: 95,
            xMax: 1100,
            yMin: 167,
            yMax: 1281,
            ha: 1114,
            leftSideBearing: 95,
            advanceWidth: 1196,
        },
        '=': {
            xMin: 85,
            xMax: 1110,
            yMin: 372,
            yMax: 1074,
            ha: 702,
            leftSideBearing: 85,
            advanceWidth: 1196,
        },
        '>': {
            xMin: 95,
            xMax: 1101,
            yMin: 166,
            yMax: 1279,
            ha: 1113,
            leftSideBearing: 95,
            advanceWidth: 1196,
        },
        '?': {
            xMin: 106,
            xMax: 1158,
            yMin: 0,
            yMax: 1481,
            ha: 1481,
            leftSideBearing: 106,
            advanceWidth: 1251,
        },
        '@': {
            xMin: 61,
            xMax: 1990,
            yMin: -431,
            yMax: 1492,
            ha: 1923,
            leftSideBearing: 61,
            advanceWidth: 1997,
        },
        A: {
            xMin: 0,
            xMax: 1471,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 0,
            advanceWidth: 1479,
        },
        B: {
            xMin: 150,
            xMax: 1378,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1479,
        },
        C: {
            xMin: 97,
            xMax: 1374,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 97,
            advanceWidth: 1479,
        },
        D: {
            xMin: 148,
            xMax: 1377,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 148,
            advanceWidth: 1479,
        },
        E: {
            xMin: 149,
            xMax: 1264,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 149,
            advanceWidth: 1366,
        },
        F: {
            xMin: 151,
            xMax: 1156,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 151,
            advanceWidth: 1251,
        },
        G: {
            xMin: 98,
            xMax: 1469,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 98,
            advanceWidth: 1593,
        },
        H: {
            xMin: 150,
            xMax: 1322,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1479,
        },
        I: {
            xMin: 140,
            xMax: 436,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 140,
            advanceWidth: 569,
        },
        J: {
            xMin: 35,
            xMax: 973,
            yMin: -25,
            yMax: 1466,
            ha: 1491,
            leftSideBearing: 35,
            advanceWidth: 1139,
        },
        K: {
            xMin: 153,
            xMax: 1475,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 153,
            advanceWidth: 1479,
        },
        L: {
            xMin: 157,
            xMax: 1189,
            yMin: 0,
            yMax: 1454,
            ha: 1454,
            leftSideBearing: 157,
            advanceWidth: 1251,
        },
        M: {
            xMin: 145,
            xMax: 1561,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 145,
            advanceWidth: 1706,
        },
        N: {
            xMin: 152,
            xMax: 1315,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 152,
            advanceWidth: 1479,
        },
        O: {
            xMin: 89,
            xMax: 1511,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 89,
            advanceWidth: 1593,
        },
        P: {
            xMin: 149,
            xMax: 1272,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 149,
            advanceWidth: 1366,
        },
        Q: {
            xMin: 89,
            xMax: 1566,
            yMin: -147,
            yMax: 1491,
            ha: 1638,
            leftSideBearing: 89,
            advanceWidth: 1593,
        },
        R: {
            xMin: 150,
            xMax: 1468,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1479,
        },
        S: {
            xMin: 74,
            xMax: 1266,
            yMin: -26,
            yMax: 1491,
            ha: 1517,
            leftSideBearing: 74,
            advanceWidth: 1366,
        },
        T: {
            xMin: 44,
            xMax: 1209,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 44,
            advanceWidth: 1251,
        },
        U: {
            xMin: 147,
            xMax: 1316,
            yMin: -25,
            yMax: 1466,
            ha: 1491,
            leftSideBearing: 147,
            advanceWidth: 1479,
        },
        V: {
            xMin: -1,
            xMax: 1364,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: -1,
            advanceWidth: 1366,
        },
        W: {
            xMin: 7,
            xMax: 1931,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 7,
            advanceWidth: 1933,
        },
        X: {
            xMin: 0,
            xMax: 1363,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 0,
            advanceWidth: 1366,
        },
        Y: {
            xMin: -3,
            xMax: 1368,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: -3,
            advanceWidth: 1366,
        },
        Z: {
            xMin: 22,
            xMax: 1213,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 22,
            advanceWidth: 1251,
        },
        '[': {
            xMin: 146,
            xMax: 644,
            yMin: -413,
            yMax: 1466,
            ha: 1879,
            leftSideBearing: 146,
            advanceWidth: 682,
        },
        '\\': {
            xMin: -3,
            xMax: 571,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: -3,
            advanceWidth: 569,
        },
        ']': {
            xMin: 38,
            xMax: 536,
            yMin: -413,
            yMax: 1466,
            ha: 1879,
            leftSideBearing: 38,
            advanceWidth: 682,
        },
        '^': {
            xMin: 115,
            xMax: 1080,
            yMin: 692,
            yMax: 1491,
            ha: 799,
            leftSideBearing: 115,
            advanceWidth: 1196,
        },
        _: {
            xMin: -19,
            xMax: 1149,
            yMin: -405,
            yMax: -223,
            ha: 182,
            leftSideBearing: -19,
            advanceWidth: 1139,
        },
        '`': {
            xMin: 42,
            xMax: 495,
            yMin: 1192,
            yMax: 1491,
            ha: 299,
            leftSideBearing: 42,
            advanceWidth: 682,
        },
        a: {
            xMin: 73,
            xMax: 1070,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 73,
            advanceWidth: 1139,
        },
        b: {
            xMin: 135,
            xMax: 1172,
            yMin: -24,
            yMax: 1466,
            ha: 1490,
            leftSideBearing: 135,
            advanceWidth: 1251,
        },
        c: {
            xMin: 85,
            xMax: 1087,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 85,
            advanceWidth: 1139,
        },
        d: {
            xMin: 84,
            xMax: 1121,
            yMin: -24,
            yMax: 1466,
            ha: 1490,
            leftSideBearing: 84,
            advanceWidth: 1251,
        },
        e: {
            xMin: 65,
            xMax: 1057.2517482517483,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 65,
            advanceWidth: 1139,
        },
        f: {
            xMin: 24,
            xMax: 742,
            yMin: 0,
            yMax: 1491,
            ha: 1491,
            leftSideBearing: 24,
            advanceWidth: 682,
        },
        g: {
            xMin: 84,
            xMax: 1120,
            yMin: -431,
            yMax: 1086,
            ha: 1517,
            leftSideBearing: 84,
            advanceWidth: 1251,
        },
        h: {
            xMin: 146,
            xMax: 1113,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 146,
            advanceWidth: 1251,
        },
        i: {
            xMin: 147,
            xMax: 428,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 147,
            advanceWidth: 569,
        },
        j: {
            xMin: -94,
            xMax: 422,
            yMin: -431,
            yMax: 1466,
            ha: 1897,
            leftSideBearing: -94,
            advanceWidth: 569,
        },
        k: {
            xMin: 137,
            xMax: 1119,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 137,
            advanceWidth: 1139,
        },
        l: {
            xMin: 147,
            xMax: 428,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 147,
            advanceWidth: 569,
        },
        m: {
            xMin: 126,
            xMax: 1688,
            yMin: 0,
            yMax: 1086,
            ha: 1086,
            leftSideBearing: 126,
            advanceWidth: 1821,
        },
        n: {
            xMin: 145,
            xMax: 1113,
            yMin: 0,
            yMax: 1086,
            ha: 1086,
            leftSideBearing: 145,
            advanceWidth: 1251,
        },
        o: {
            xMin: 82,
            xMax: 1178,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 82,
            advanceWidth: 1251,
        },
        p: {
            xMin: 139,
            xMax: 1175,
            yMin: -404,
            yMax: 1086,
            ha: 1490,
            leftSideBearing: 139,
            advanceWidth: 1251,
        },
        q: {
            xMin: 91,
            xMax: 1122,
            yMin: -404,
            yMax: 1086,
            ha: 1490,
            leftSideBearing: 91,
            advanceWidth: 1251,
        },
        r: {
            xMin: 135,
            xMax: 823,
            yMin: 0,
            yMax: 1086,
            ha: 1086,
            leftSideBearing: 135,
            advanceWidth: 797,
        },
        s: {
            xMin: 48,
            xMax: 1040,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 48,
            advanceWidth: 1139,
        },
        t: {
            xMin: 31,
            xMax: 657,
            yMin: -24,
            yMax: 1437,
            ha: 1461,
            leftSideBearing: 31,
            advanceWidth: 682,
        },
        u: {
            xMin: 141,
            xMax: 1107,
            yMin: -24,
            yMax: 1062,
            ha: 1086,
            leftSideBearing: 141,
            advanceWidth: 1251,
        },
        v: {
            xMin: 11,
            xMax: 1114,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 11,
            advanceWidth: 1139,
        },
        w: {
            xMin: 9,
            xMax: 1592,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 9,
            advanceWidth: 1593,
        },
        x: {
            xMin: 12,
            xMax: 1120,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 12,
            advanceWidth: 1139,
        },
        y: {
            xMin: 14,
            xMax: 1106,
            yMin: -431,
            yMax: 1062,
            ha: 1493,
            leftSideBearing: 14,
            advanceWidth: 1139,
        },
        z: {
            xMin: 34,
            xMax: 982,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 34,
            advanceWidth: 1024,
        },
        '{': {
            xMin: 60,
            xMax: 744,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 60,
            advanceWidth: 797,
        },
        '|': {
            xMin: 176,
            xMax: 399,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 176,
            advanceWidth: 573,
        },
        '}': {
            xMin: 45,
            xMax: 729,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 45,
            advanceWidth: 797,
        },
        '~': {
            xMin: 67,
            xMax: 1129,
            yMin: 519,
            yMax: 924,
            ha: 405,
            leftSideBearing: 67,
            advanceWidth: 1196,
        },
    },
    fontFamily: 'Arial',
    resolution: 2048,
    generatedOn: '2022-11-04T20:05:21.000Z',
};
